import { JoinOrgForm } from "@/components/auth/join-org-form.tsx";
import { m } from "@/paraglide/messages.js";
import { EMAIL_TOKEN_REGEX } from "@/utils/validation.ts";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { pageTitle } from "@/utils/page-title.ts";

const joinRouteSchema = z.object({
	email: z.email(),
	org: z.uuid(),
	token: z.string().regex(EMAIL_TOKEN_REGEX),
});

export const Route = createFileRoute("/auth/join")({
	component: RegisterComponent,
	validateSearch: joinRouteSchema,
	beforeLoad: ({ search }) => {
		const result = joinRouteSchema.safeParse(search);
		if (!result.success) {
			throw redirect({
				to: "/auth/login",
				replace: true,
			});
		}
	},
	head: () => ({
		meta: [{ title: pageTitle(m.auth_join_title()) }],
	}),
});

function RegisterComponent() {
	return <JoinOrgForm />;
}
